export type SearchFormEquipments = Pick<SearchFilters, 'equipments'>
export const useSearchFiltersFormEquipments = (formRef: Ref<SearchFormEquipments> | undefined = undefined) => {
  const { filters } = storeToRefs(useSearchStore())

  const formEquipments = formRef === undefined
    ? ref<SearchFormEquipments>({
        equipments: [],
      })
    : formRef

  const initFormEquipements = () => {
    formEquipments.value.equipments = [...filters.value.equipments]
  }

  return {
    formEquipments,
    initFormEquipements,
  }
}
